import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EventsState } from '../../../../../store/types';
import Icon, { ICONS, COLORS } from '../../../../general-ui/icon';
import './video.scss';
import { ColorKeys, LanguagesAbbr } from '../../../../../types/working-model';
import SessionStream from '../../../../live-event/session/session-stream/session-stream';
import EditSectionColorsModal, { EContentColorOverrideNames } from './moduleControls/edit-section-colors-modal';
import { setVideoCustomizations } from '../../../../../store/actions/admin/create-event/session';
import BroadcastOptionsModal from '../../homepage/navigation/broadcast-options-modal';
import classNames from 'classnames';
import { TemplateClassNames } from '../../../../../types/template-layouts';

// function parseBroadcastTime(lang: string, timestamp: string | number) {
// 	const date = new Date(timestamp);

// 	if (date.valueOf() > Date.now()) {
// 		return `Scheduled for ${date.toLocaleString(lang, { weekday: 'long', month: 'long', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}`;
// 	}
// }

interface VideoProps {
	editorSize: string;
	language?: LanguagesAbbr;
}

const Video: React.FC<VideoProps> = ({ editorSize, language }) => {
	const {
		CreateSessionReducer: {
			workingSession
		},
		CreateEventReducer: {
			workingEvent
		},
	} = useSelector((state: EventsState) => state);
	const [openStyleModal, setOpenStyleModal] = useState(false);
	const [optionsModalOpen, setOptionsModalOpen] = useState(false);

	const dispatch = useDispatch();

	const template = workingEvent?.template.name
		? TemplateClassNames[workingEvent!.template.name]
		: TemplateClassNames.Apollo;

	const handleFinishStyling = useCallback((colorKey: string) => {
		if (colorKey.startsWith('https://')) {
			dispatch(setVideoCustomizations({
				backgroundImage: colorKey,
				backgroundColor: undefined
			}));
		} else {
			dispatch(setVideoCustomizations({
				backgroundImage: undefined,
				backgroundColor: colorKey as ColorKeys
			}));
		}
	}, [dispatch]);

	const handleCancelStyling = useCallback(() => {
		setOpenStyleModal(false);
	}, []);

	const styleOverrides = useMemo(() => {
		if (workingSession?.video?.customizations?.backgroundColor) {
			return { backgroundColor: `var(--${workingSession?.video?.customizations?.backgroundColor})` };
		}

		if (workingSession?.video?.customizations?.backgroundImage) {
			return { backgroundImage: `url(${workingSession?.video?.customizations?.backgroundImage})` };
		}

		return {};
	}, [workingSession]);

	return workingSession && (
		<>
			<div className={classNames("editor-wrapper broadcast", template)} style={styleOverrides}>
				<div className="container">
					{workingEvent && (
						<SessionStream
							session={workingSession}
							eventBundle={workingEvent}
							isEditor
							editorSize={editorSize}
							isAdmin={true}
							language={language}
						/>
					)}
					<div className="video-actions">
						<button className="button round" onClick={() => setOpenStyleModal(true)}>
							<Icon
								name={ICONS.PAINTBRUSH}
								color={COLORS.WHITE}
								size={12}
								backgroundColor={COLORS.DARK_GREY}
							/>
						</button>
						<button className="button round" onClick={() => setOptionsModalOpen(true)}>
							<Icon
								name={ICONS.EDIT}
								color={COLORS.WHITE}
								size={12}
								backgroundColor={COLORS.DARK_GREY}
							/>
						</button>
					</div>
				</div>

			</div>
			<EditSectionColorsModal
				open={openStyleModal}
				title={EContentColorOverrideNames.background}
				backgroundImage={workingSession.image ?? undefined}
				onFinish={handleFinishStyling}
				onClose={handleCancelStyling}
				allowBackgroundImage={false}
			/>
			<BroadcastOptionsModal
				isOpen={optionsModalOpen}
				onClose={() => setOptionsModalOpen(false)}
			/>
		</>
	);
};

export default Video;
